export const statusOptions = [
  { label: "Open", value: "open" },
  { label: "Paid", value: "paid" },
  { label: "Unresolved", value: "unresolved" },
  { label: "Viewed", value: "viewed" },
  { label: "Void", value: "void" },
]

export const orderOptions = [
  { label: "Oldest", value: "asc" },
  { label: "Newest", value: "desc" },
]
